import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	.tooltip-share-icons {
		display: flex;
		justify-content: space-between;
		align-items: center;

		> * {
			margin-right: 1em;
			cursor: pointer;

			.icon {
				max-width: 2em;
			}
			&:last-of-type {
				margin-right: 0;
			}
		}
		.copy-link {
			all: unset;
			cursor: pointer;
		}
	}

	.button {
		.button-icon-before {
			width: 2em;
		}

		.button-icon-before-hover {
			width: 2em;
		}

		&:hover {
			.button-content {
				text-decoration: underline;
			}
		}
	}

	&.disabled {
		filter: invert(78%) sepia(3%) saturate(0%) hue-rotate(183deg)
			brightness(102%) contrast(86%);
		pointer-events: none;
	}
	@media all and (max-width: ${variables.mobileL}) {
		.button {
			.button-content {
				display: none;
			}
		}
	}
`;
